import React from 'react';
import IconCheck from './icons/check';
import styled from 'styled-components';
import colors from '../design/colors';

interface CheckboxProps {
  checked: boolean;
  setChecked?: (checked: boolean) => void;
  size?: string;
  checkIconSize?: string;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void; // stopPropagation 처리 위한 option
  stopPropagation?: boolean;
}

const Checkbox = ({
  checked,
  setChecked,
  size = '24px',
  style,
  checkIconSize,
  onClick,
  stopPropagation = true,
}: CheckboxProps) => {
  const resolvedcheckIconSize = checkIconSize ?? `calc(${size} - 8px)`;

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    stopPropagation && e.stopPropagation(); // 예: 부모 tr 클릭 막기
    onClick?.(e);
    setChecked?.(!checked);
  };

  return (
    <CheckWrapper
      size={size}
      $checkIconSize={resolvedcheckIconSize}
      onClick={handleClick}
      checked={checked}
      style={style}
    >
      {checked && (
        <IconCheck
          color={colors.white}
          width={resolvedcheckIconSize}
          height={resolvedcheckIconSize}
        />
      )}
    </CheckWrapper>
  );
};

export default Checkbox;

const CheckWrapper = styled.div<{
  size: string;
  checked: boolean;
  $checkIconSize: string;
}>`
  width: ${(props) => props.size} !important;
  height: ${(props) => props.size} !important;
  border-radius: 4px;
  border: 1px solid
    ${(props) => (props.checked ? colors.blue600 : colors.gray200)};
  background-color: ${(props) =>
    props.checked ? colors.blue600 : colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
`;
